//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { SalesRefund } from '../../graphql/entities';
import Formatters from '../../components/grid-addons/formatters';
import { usePredefinedFilters } from '../../getPredefinedFilters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { Direction, ISalesRefund } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';
import { ModalFormatter } from '../../components/grid-addons/formatters/ModalFormatter';

const LazyCustomerForm = React.lazy(() => import('../../views/customer/CustomerForm'));

const { readOnlyStatus, formUrl, type, title, workspace } = SalesRefund;

const SALES_REFUND_FIELD_NAMES: Array<Paths<ISalesRefund>> = [
  'documentNumber',
  'documentDate',
  'documentStatus',
  'customer.reference',
  'customer.name',
  'documentReference',
  'paymentMethod.description',
  'documentAmount',
  'discountAmount',
  'reconciled',
  'bankChargeAmount',
];

const SALES_REFUND_COLUMN_OVERRIDES = {
  documentNumber: {
    name: 'Number',
    key: 'documentNumber',
    width: 100,
  },
  documentStatus: {
    name: 'Status',
    width: 80,
    formatter: Formatters.DocumentStatusFormatter,
  },
  postingDate: {
    name: 'Posting Date',
    key: 'postingDate',
    formatter: 'date',
    width: 110,
  },
  documentDate: {
    name: 'Date',
    key: 'documentDate',
    formatter: 'date',
    width: 110,
  },
  documentAmount: {
    name: 'Amount Refunded',
    formatter: Formatters.NumericFormatter,
    options: {
      format: { decimals: 2 },
    },
  },
  'customer.reference': {
    name: 'Customer',
    formatter: ModalFormatter,
    width: 125,
    options: {
      modalContent: LazyCustomerForm,
      modalProps: { forceReadOnly: true },
      entityId: 'customer.id',
    },
  },
};

const SalesRefundWorkspace = (props) => {
  const predefinedFilters = usePredefinedFilters(props);
  const workspaceProps = useWorkspace<ISalesRefund>(props, SalesRefund, {
    filters: predefinedFilters,
    columns: SALES_REFUND_FIELD_NAMES,
    columnOverrides: SALES_REFUND_COLUMN_OVERRIDES,
    initialSortColumn: 'documentNumber',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={type}
      title={title}
      formUrl={formUrl}
      defaultQuery={workspace}
      readOnlyStatus={readOnlyStatus}
      {...workspaceProps}
      {...props}
      entity={SalesRefund}
    />
  );
};

export default SalesRefundWorkspace;
